import script from "./TressAccountRegisterBusinessForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./TressAccountRegisterBusinessForm.vue?vue&type=script&lang=ts&setup=true"

import "./TressAccountRegisterBusinessForm.vue?vue&type=style&index=0&id=6d346e11&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d346e11"]])

export default __exports__